import { Link } from "react-router-dom";
import { mediaList, type MediaType } from "@/mocks/movies";
import { typeMeta } from "@/lib/media";

interface CollectionItem {
  title: string;
  subtitle: string;
  type: MediaType;
  genre: string;
  to: string;
  cover: string;
}

const collections: CollectionItem[] = [
  {
    title: "城市夜行 · 悬疑片单",
    subtitle: "雨夜、旧案与不肯开口的人",
    type: "movie",
    genre: "悬疑",
    to: "/category/movie?genre=%E6%82%AC%E7%96%91",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20city%20street%20in%20the%20rain%20with%20warm%20amber%20lamps%20and%20deep%20shadows%2C%20wet%20asphalt%20reflections%2C%20a%20single%20silhouette%20under%20a%20streetlight%2C%20muted%20peach%20tones%2C%20moody%20crime%20film%20atmosphere&width=800&height=500&seq=mt-col-suspense&orientation=landscape",
  },
  {
    title: "慢下来的生活 · 治愈剧集",
    subtitle: "小院、便利店与长街晚风",
    type: "tv",
    genre: "治愈",
    to: "/category/tv?genre=%E6%B2%BB%E6%84%88",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20sunlit%20courtyard%20with%20a%20wooden%20table%2C%20teapot%20and%20peach%20blossom%20petals%20in%20the%20air%2C%20soft%20cream%20and%20peach%20color%20palette%2C%20gentle%20spring%20afternoon%20light%2C%20peaceful%20healing%20drama%20mood%2C%20film%20still&width=800&height=500&seq=mt-col-healing&orientation=landscape",
  },
  {
    title: "山野与厨房 · 户外综艺",
    subtitle: "把餐桌搬到没有信号的地方",
    type: "variety",
    genre: "户外",
    to: "/category/variety?genre=%E6%88%B7%E5%A4%96",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20fire%20cooking%20in%20a%20wild%20meadow%20at%20golden%20hour%20with%20cast%20iron%20pot%20and%20smoke%2C%20warm%20peach%20and%20amber%20tones%2C%20distant%20mountains%2C%20cozy%20outdoor%20reality%20show%20atmosphere%2C%20cinematic%20still&width=800&height=500&seq=mt-col-variety&orientation=landscape",
  },
];

export default function Collections() {
  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16" aria-label="热门推荐专题">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-primary-600">Curated collections</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[30px]">
            热门推荐专题
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-foreground-500">
          按情绪和场景整理的小片单，点进去就能看到同主题的全部作品。
        </p>
      </div>

      <div className="grid gap-3 md:gap-5 lg:grid-cols-3">
        {collections.map((collection, index) => (
          <Link
            key={collection.title}
            to={collection.to}
            className="group relative block h-56 cursor-pointer overflow-hidden rounded-lg bg-foreground-900 md:h-64"
          >
            <img
              src={collection.cover}
              alt={collection.title}
              title={`${collection.title} - 蜜桃33专题`}
              className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-foreground-950/10" />
            <div className="absolute inset-0 flex flex-col justify-between p-5 md:p-6">
              <div className="flex items-center justify-between">
                <span className="rounded-full border border-background-50/30 px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] text-background-100/85">
                  Collection {String(index + 1).padStart(2, "0")}
                </span>
                <span className="text-[11px] text-background-200/75">
                  {mediaList.filter((item) => item.type === collection.type && item.genres.includes(collection.genre)).length}{" "}
                  部{typeMeta[collection.type].label}
                </span>
              </div>
              <div>
                <h3 className="font-heading text-lg font-bold text-background-50 md:text-xl">
                  {collection.title}
                </h3>
                <p className="mt-1.5 text-xs text-background-200/80">{collection.subtitle}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
                  查看片单
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}